import { Command } from 'commands/Commands';

export class ChangeArticleAltText extends Command {
  type: string = 'BlogArticle.ChangeAltText';
  constructor(public id: string, newValue: string) {
    super(newValue, id);
  }
  priority: number = 100;
}
